import React, { Component } from "react";
// import MultipleValueTextInput from "react-multivalue-text-input";
import { onChange, validateForm } from "../../utils";

export default class forward extends Component {
    constructor(props) {
        super(props);
        this.state = {
            remark: { name: "remark", value: "", error: "", isRequired: true },
        };
    }
    onChange = (e) => {
        const { name, value } = e.target;
        onChange(this, name, value);

    };

    onSubmit = (e) => {
        e.preventDefault();
        if (validateForm(this)) {
            const { remark } = this.state;
            const model = {
                REMARK: remark.value,
            };
            this.props.onSubmit(model);
        }
    };

    render() {
        const { remark } = this.state;
        return (
            <React.Fragment>
                <form onSubmit={this.onSubmit}>
                    <div className="d-flex">
                        <textarea
                            type="text"
                            className="form-input "
                            name={remark.name}
                            value={remark.value}
                            onChange={this.onChange}
                            rows={5}
                            style={{ width: "95%", border: "none",padding:"2px 6px" }}
                            placeholder="Remark"
                        />
                    </div>
                    <div className="d-flex justify-content-between mt-3">
                        <button className="btn btn-primary" type="submit">
                            Add
                        </button>
                        <button
                            className="btn btn-danger"
                            type="cancel"
                            onClick={this.props.toggleModal}
                        >
                            Cancel
                        </button>
                    </div>
                </form>
            </React.Fragment>
        );
    }
}
